<template lang="pug">
#app
  v-navigation-drawer#appDrawer(fixed, light, app, v-model='drawer', width="280px", style="display: flex; flex-direction: column; top: var(--env-banner-height, 0px);")
    v-toolbar(color='white light', flat, style="box-shadow: inset 0px -2px 0px 0px rgba(204,204,209,1)!important;")
      img(v-bind:src='logo', height='40', alt='Bigou Delivery', style="margin:auto;")
    v-layout.py-2(row, wrap, style="gap: 5px")
      v-flex.mr-3(v-if="!$root.pedido_mobile && $vuetify.breakpoint.mdAndUp")
        v-btn.botaoBarraLateral(flat, slot='activator', @click="() => {}")
          v-layout(row, wrap)
            v-flex.md12.text-xs-left.py-1
              .caption Conexão
          v-tooltip(bottom)
            template(v-slot:activator="{ on, attrs }")
              v-icon.dot.right(:color="$root.socketConnected ? 'primary' : 'red'", small, v-bind="attrs", v-on="on"
                :class="{'connected': $root.socketConnected, 'disconnected': !$root.socketConnected}").fa fa-circle
        v-btn.botaoBarraLateral(flat, slot='activator', @click="connectPrinter", v-if="$root.driver && $root.driver.id == 2")
          v-layout(row, wrap)
            v-flex.md12.text-xs-left.py-1
              .caption Impressora
              .ma-0(style="font-size: 9px", v-if="$root.printerConnected") {{ $root.printer && $root.printer.length ? getNomeImpressoras($root.printer) : 'SELECIONAR' }}
          v-tooltip(bottom)
            template(v-slot:activator="{ on, attrs }")
              v-icon.dot.right(:color="$root.printerConnected ? 'primary' : 'red'", small, v-bind="attrs", v-on="on"
                :class="{'connected': $root.printerConnected, 'disconnected': !$root.printerConnected}").fa fa-circle
            span {{ $root.printerConnected ? 'Impressora conectada' : 'Impressora desconectada' }}
      v-flex.mr-3(v-if="!$root.pedido_mobile && $vuetify.breakpoint.mdAndUp && checkVisibility(estabelecimentoSelecionado, 'entrega')")
        v-btn.botaoBarraLateral.my-0(flat, slot='activator', @click="atalhoBloqueado ? openDialogOnboarding() : openDialogTempoEntrega()", :class="{ 'botaoBarraLateral--bloqueado': atalhoBloqueado }")
          v-layout(row, wrap)
            v-flex.md12.text-xs-left.py-1
              .caption Tempo de entrega
              .ma-0(style="font-size: 9px") {{ getTempoEntrega() ? `(${getTempoEntrega()})` : '' }}
          v-icon(right, size="18", color="gray") {{ atalhoBloqueado ? 'lock' : 'timer' }}
      v-flex.mr-3(v-if="!$root.pedido_mobile && $vuetify.breakpoint.mdAndUp && checkVisibility(estabelecimentoSelecionado, 'retirada')")
        v-btn.botaoBarraLateral.my-0(flat, slot='activator', @click="atalhoBloqueado ? openDialogOnboarding() : openDialogTempoRetirada()", :class="{ 'botaoBarraLateral--bloqueado': atalhoBloqueado }")
          v-layout(row, wrap)
            v-flex.md12.text-xs-left.py-1
              .caption Tempo de retirada
              .ma-0(style="font-size: 9px") {{ getTempoRetirada() ? `(${getTempoRetirada()})` : '' }}
          v-icon(right, size="18", color="gray") {{ atalhoBloqueado ? 'lock' : 'timer' }}
    //- Card de progresso do onboarding (só exibe após dados carregados)
    .onboarding-progress-card(
      v-if="$root.onboardingData && ($root.isOnboardingPendente || $root.isOnboardingAguardando)"
      @click="openDialogOnboarding()"
    )
      .opc-top(:class="{ 'opc-top--mb': $root.isOnboardingPendente }")
        .opc-icon-wrap(:class="$root.isOnboardingAguardando ? 'icon-amber' : 'icon-green'")
          v-icon(color="white", size="16") {{ $root.isOnboardingAguardando ? 'hourglass_empty' : 'store' }}
        .opc-textos
          .opc-titulo.Poppins {{ $root.isOnboardingAguardando ? 'Aguardando ativação' : 'Loja em configuração' }}
          .opc-subtitulo(v-if="$root.isOnboardingPendente && $root.onboardingEtapaAtualLabel") Etapa atual: {{ $root.onboardingEtapaAtualLabel }}
          .opc-subtitulo(v-else-if="$root.isOnboardingAguardando") Pedidos de teste pendentes
        .opc-badge {{ $root.onboardingConcluidas }}/{{ $root.onboardingTotal }}
      .opc-barra-wrap(v-if="$root.isOnboardingPendente")
        .opc-barra-fundo
          .opc-barra-fill(:style="{ width: $root.onboardingPct + '%' }")
        .opc-pct {{ $root.onboardingPct }}%

    vue-perfect-scrollbar.drawer-menu--scroll(:settings='scrollSettings')
      v-list
        template(v-for='(item, i) in menus')
          v-list-tile(active-class="br-5 bgCustom opcaoAtivada dark-1 primary--text font-weight-bold", :to='itemBloqueado(item) ? null : (item.name ? { name: item.name } : null)', @click='onClickMenu(item);', :disabled='item.disabled', rel='noopener', :key='item.name', v-if="!item.show || (!!item.show && !!$root[item.show])", :class="{ 'menu-item--bloqueado': itemBloqueado(item) }")
            v-list-tile-action(v-if="item.icon")
              img(:src="require('@/assets/images/icons/' + (item.seletor == getCurrentPath() ? item.iconFilled : item.icon))"
                style="max-width:24px;"
              )
            v-list-tile-content
              v-list-tile-title.body-1 {{ item.title }}
            //- Durante o onboarding, só a tela da etapa atual fica liberada
            v-list-tile-action(v-if="itemBloqueado(item)")
              v-icon(small, color="grey lighten-1") lock
            v-list-tile-action(v-else-if="item.badge && $root[item.badge]", class="badgeEditado", style="z-index: 9999 !important; transform: translateY(-3px);")
              v-badge(color='red', overlap, bordered="true")
                span(slot='badge') {{ $root[item.badge] }}
        v-list-tile(href="https://play.google.com/store/apps/details?id=br.com.labcinco.bigoupedidos", target="_blank").hidden-sm-and-down
          v-list-tile-action
            v-icon.fa fa-android
          v-list-tile-content
            v-list-tile-title.body-1 Baixar App Android
        v-list-tile(href="https://apps.apple.com/br/app/bigou-pedidos/id1256664611", target="_blank").hidden-sm-and-down
          v-list-tile-action
            v-icon.fa.fa-apple
          v-list-tile-content
            v-list-tile-title.body-1 Baixar App iOS
        v-list-tile(:href="linkSuporte", target="_blank", @click="contatarSuporte('menu_lateral')")
          v-list-tile-action
            v-icon support_agent
          v-list-tile-content
            v-list-tile-title.body-1 Suporte
            v-list-tile-sub-title.caption (32) 98892-9726

        DialogShare(ref="dialogShare")
        DialogTempoEntrega(ref="dialogTempoEntrega", @refresh="refresh")
        DialogTempoRetirada(ref="dialogTempoRetirada", @refresh="refresh")
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import logo from "@/assets/images/logo-delivery-verde.svg";
import menu from "@/menu";
import DialogShare from '@/components/dialog/DialogShare';
import DialogTempoEntrega from '@/components/dialog/DialogTempoEntrega';
import DialogTempoRetirada from '@/components/dialog/DialogTempoRetirada';
import { etapaAtualDe, SELETORES_LIBERADOS, WHATSAPP_SUPORTE } from '@/util/onboarding';
import { registrarContatoSuporte } from '@/util/suporte';
import _ from 'lodash';

export default {

  name: "app-drawer",
  components: {
    VuePerfectScrollbar,
    DialogShare,
    DialogTempoEntrega,
    DialogTempoRetirada,
  },
  props: {
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    drawer: true,
    menus: [],
    iconAtivo: null,
    logo: logo,
    linkSuporte: `https://api.whatsapp.com/send?phone=${WHATSAPP_SUPORTE}`,
    scrollSettings: {
      maxScrollbarLength: 160
    },
    estabelecimento: null,
    listaRecesso: null,
    recessos: null,
  }),
  computed: {
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
    // Os atalhos de tempo de entrega/retirada abrem diálogos de configuração fora
    // da tela da etapa atual — durante o onboarding esses tempos devem ser
    // ajustados na etapa de Configurações.
    atalhoBloqueado(){
      if (!this.$root.isOnboardingPendente) return false;
      return !!etapaAtualDe(this.$root.onboardingData);
    },
  },
  watch: {
  },
  created () {
    const vm = this;
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      vm.drawer = !vm.drawer;
    });
    this.getCurrentPath()
    window.getApp.$on("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  beforeDestroy() {
    window.getApp.$off("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  mounted(){
    this.onChangeEstabelecimento();
  },
  methods: {
    checkVisibility(estab, tipo){
      if(!estab) return true;
      else if(tipo == 'entrega') return estab.delivery[0].dias_entrega && estab.delivery[0].dias_entrega !== ''
      else if(tipo == 'retirada') return estab.delivery[0].dias_retirada && estab.delivery[0].dias_retirada !== ''
      else false;
    },
    getMenusDisponiveis(){
      let menus = menu;
      if(this.$root.estabelecimentoSelecionado && this.$root.estabelecimentoSelecionado.cardapio_digital){
        menus = _.reject(menus, (o)=>{
          return o.seletor == 'avaliacoes' || o.seletor == 'notificacao' || o.seletor == 'perguntas-frequentes';
        })
      }

      const perfilAcesso = (this.$root.user && this.$root.user.perfil_acesso) || 'administrador';
      menus = _.filter(menus, (o) => !o.perfis || o.perfis.includes(perfilAcesso));

      return menus;
    },
    onChangeEstabelecimento(){
      console.log('CHANGE_ESTABELECIMENTO MENU', this.estabelecimentoSelecionado)
      this.menus = this.getMenusDisponiveis();
    },
    refresh(){
      this.$forceUpdate()
    },
    getCurrentPath(){
      const path = this.$route.path;
      const segment = path.split('/')[2];
      // Sub-páginas de marketing devem manter o highlight no menu Marketing
      if (segment === 'cupom-desconto') return 'marketing';
      return segment;
    },

    doClick (click) {
      if (click && this[click]) this[click]();
      else if (click && this.$root[click]) this.$root[click]();
    },

    // Durante o onboarding o parceiro fica restrito à tela da etapa da vez, para
    // não se perder pelo painel antes de concluir a configuração da loja.
    itemBloqueado (item) {
      if (!this.$root.isOnboardingPendente) return false;
      const etapa = etapaAtualDe(this.$root.onboardingData);
      if (!etapa) return false;
      if (SELETORES_LIBERADOS.includes(item.seletor)) return false;
      return item.seletor !== etapa.seletor;
    },

    onClickMenu (item) {
      // Item bloqueado reabre o onboarding em vez de navegar.
      if (this.itemBloqueado(item)) {
        this.openDialogOnboarding();
        return;
      }
      this.doClick(item.click);
    },

    compartilhar () {
      this.$refs.dialogShare.open();
    },

    openDialogOnboarding () {
      window.getApp.$emit('OPEN_ONBOARDING');
    },

    contatarSuporte (origem) {
      registrarContatoSuporte(origem, this.estabelecimentoSelecionado);
    },

    openContrato () {
      const venda = this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.vendas ? _.find(this.estabelecimentoSelecionado.vendas, o => {
        return o.status == this.$root.enums.STATUS.VENDA_ATIVA || o.status == this.$root.enums.STATUS.VENDA_SUSPENSA || o.status == this.$root.enums.STATUS.VENDA_PENDENTE;
      }) : null;
      if (!venda || !venda.contrato_url || venda.contrato_status != this.$root.enums.STATUS.CONTRATO_PENDENTE) {
        return;
      }
      window.open(venda.contrato_url);
    },

    async connectPrinter () {
      const vm = this;
      try {
        await vm.$root.connectPrinter();
        vm.$root.openDialogPrinter();
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'orange darken-1', text: error.message });
      }
    },
    getNomeImpressoras(printers){
      return printers.map(printer => printer.nome).filter(Boolean).join(' / ');
    },
    openDialogTempoEntrega(){
      this.$refs.dialogTempoEntrega.open(this.$root.estabelecimentoSelecionado);
    },
    openDialogTempoRetirada(){
      this.$refs.dialogTempoRetirada.open(this.$root.estabelecimentoSelecionado);
    },
    getTempoEntrega(){
      const delivery = this.$root.estabelecimentoSelecionado && this.$root.estabelecimentoSelecionado.delivery ? this.$root.estabelecimentoSelecionado.delivery[0] : null
      return delivery ? this.secToMin(delivery.tempo_entrega) : '';
    },
    getTempoRetirada(){
      const delivery = this.$root.estabelecimentoSelecionado && this.$root.estabelecimentoSelecionado.delivery ? this.$root.estabelecimentoSelecionado.delivery[0] : null
      return delivery ? this.secToMin(delivery.tempo_retirada) : '';
    },
    secToMin(minutes) {
      let hours = Math.floor(minutes / 60);
      let remainingMinutes = minutes % 60;
      let result = '';

      if (hours > 0) {
        result += hours > 1 ? `${hours} horas` : `${hours} hora`;
      }

      if (remainingMinutes > 0) {
        if(result.length > 0){
          result += ', ';
        }
        result += remainingMinutes > 1 ? `${remainingMinutes} minutos` : `${remainingMinutes} minuto`;
      }

      return result;
    },
  }
}
</script>

<style lang="scss" scoped>
.btnDelivery{
  height: 50px;
  border-radius: 7px;
  border: 2px solid #de2934!important;
}
.btnDelivery .v-btn__content{
  display: flex;
  flex-direction: row;
  gap: 5px;
}
</style>
<style lang="scss">
#appDrawer {
  font-family: 'Poppins', 'Roboto', sans-serif;
  overflow: hidden;
  background-color: #ffffff;
  .drawer-menu--scroll {
    height: calc(100vh - 48px - var(--env-banner-height, 0px));
    overflow: auto;
  }
}

.v-list__tile__title {
  min-height: 20px;
  height: auto;
  white-space: normal;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.5, 1) !important;
}
.v-list__tile__action {
  min-width: 40px !important;
}

.itemRecesso{
  background-color: #f5f5f5;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  .v-list__tile{
    height: auto!important;
  }
}
.bold-text{
  font-size: 25px !important;
}
.opcaoAtivada .v-list__tile__title {
  font-weight: 600 !important;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.5, 1) !important;
}
.br-5{
  border-radius: 5px !important;
}
.br-10{
  border-radius: 10px !important;
}
.v-dialog {
  border-radius: 17px!important;
  border: 6px solid #d2d2d7!important;
  margin: 14px!important;
}

.v-dialog::-webkit-scrollbar {
    width: 0px;
}

.v-dialog::-webkit-scrollbar-track {
    -webkit-box-shadow: none;
}

.btnSupporte{
  color: #fff;
  height: 80%;
  font-size: 15px;
  font-weight: 700;
  background-color: #1d9a5a!important;
  text-transform: capitalize;
  border-radius: 12px;
}

.botaoBarraLateral{
  color: #fff;
  height: auto!important;
  width: 100%;
  font-size: 15px;
  font-weight: 700;
  background-color:#fefefe!important;
  text-transform: capitalize;
  border-radius: 8px!important;
  border: 1px solid rgb(226, 226, 226);
  box-shadow: 2px 4px 12px #00000014;
  cursor: pointer;
  border: 2px solid rgb(226, 226, 226);

  &:hover{
    border: 2px solid #32ba72;
  }
}

.botaoBarraLateral--bloqueado {
  opacity: 0.5;
  cursor: not-allowed;

  &:hover{
    border: 2px solid rgb(226, 226, 226);
  }
}

.menu-item--bloqueado {
  opacity: 0.45;

  .v-list__tile {
    cursor: not-allowed;
  }

  img {
    filter: grayscale(100%);
  }
}

.botaoOnboarding {
  border: 2px solid #F59E0B !important;
  background-color: #FFFBEB !important;

  &:hover {
    border: 2px solid #D97706 !important;
    background-color: #FEF3C7 !important;
  }
}

.onboarding-progress-card {
  margin: 0 8px 8px;
  min-width: 260px;
  background: #fff;
  box-shadow: 2px 4px 12px #00000014;
  border: 2px solid #e2e2e2;
  border-radius: 8px;
  padding: 12px 14px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s, border-color 0.2s;

  &:hover {
    border-color: #1d9a5a;
    box-shadow: 0 4px 14px rgba(29, 154, 90, 0.12);
  }
}

.opc-top {
  display: flex;
  align-items: center;
  gap: 10px;

  &--mb { margin-bottom: 10px; }
}

.opc-icon-wrap {
  width: 32px; height: 32px;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;

  &.icon-green { background: #1d9a5a; }
  &.icon-amber { background: #F59E0B; }
}

.opc-textos {
  flex: 1;
  min-width: 0;
}

.opc-titulo {
  font-size: 12px;
  font-weight: 700;
  color: #212121;
  line-height: 1.2;
}

.opc-subtitulo {
  font-size: 10px;
  color: #757575;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.opc-badge {
  font-size: 11px;
  font-weight: 700;
  color: #1d9a5a;
  background: #e8f5e9;
  border-radius: 20px;
  padding: 2px 8px;
  flex-shrink: 0;
}

.opc-barra-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.opc-barra-fundo {
  flex: 1;
  height: 6px;
  background: #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
}

.opc-barra-fill {
  height: 100%;
  background: linear-gradient(90deg, #1d9a5a, #34d399);
  border-radius: 3px;
  transition: width 0.4s ease;
}

.opc-pct {
  font-size: 10px;
  font-weight: 700;
  color: #1d9a5a;
  flex-shrink: 0;
  min-width: 28px;
  text-align: right;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 5px;
}

.connected {
  background-color:#32ba72;
  animation: pulseGreen 2s infinite;
}

.disconnected {
  background-color: #FF4B4B;
}

@keyframes pulseGreen {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(50, 186, 114, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(50, 186, 114, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(50, 186, 114, 0);
  }
}

</style>

<style>
.bgCustom {
  background-color: #fafafa !important;
}
.v-navigation-drawer__border{
  background-color: transparent !important;
}
.opcaoAtivada::before{
  content: "";
  position: absolute;
  top: -20px;
  width: 20px;
  right: 0;
  height: 20px;
  background-color: #fff !important;
  border-radius: 50%;
  box-shadow: 10px 10px 0 #fafafa;
  transition-delay: 0.55ms !important;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.5, 1) !important;
  z-index: -1;
}
.opcaoAtivada::after{
  content: "";
  position: absolute;
  bottom: -20px;
  width: 20px;
  right: 0;
  height: 20px;
  background-color: #fff !important;
  border-radius: 50%;
  box-shadow: 10px -10px 0 #fafafa;
  transition-delay: 0.55s !important;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.5, 1) !important;
  z-index: -1;
}

.cardRecessoAdmin{
  border-radius:8px !important;
  .botoesLogin{
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: stretch;
  }
}

.areaTituloCard{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

    .v-icon{
      background-color: #f2f2f2;
      border-radius: 50%;
      padding: 2px;
      font-size: 22px;
      cursor: pointer;
      user-select: none;
    }

    .v-icon:hover{
      background-color: #dcdcdc;
      border-radius: 50%;
      padding: 2px;
      font-size: 22px;
    }
}

</style>
